import {
	replaceImage
} from '../productDisplay/_images.js';

export var goToNextImage = function($img) {
    if ($(".chanel-banner").length == 0) {
        if ($img.data("alternates") != undefined && $img.data("alternates") != "") {
            var oldArrayList = $img.data("alternates").split('|');
            var oldImage = oldArrayList.splice(0, 1);

            if (oldImage != null && oldImage != '') {
                $("#shareImage_" + $img.data("catentryid")).val(oldImage);
                replaceImage($img, oldImage[0]);
                $img.data("alternates", oldArrayList.join('|') + "|" + oldImage);
            }
        }
    }
};
